var render = function render(){var _vm=this,_c=_vm._self._c;return (true === _vm.display)?_c('v-container',{staticClass:"pageLoader",style:(_vm.style)},[_c('v-layout',{staticClass:"align-center justify-center fill-height",attrs:{"column":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":_vm.size,"color":"primary"}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }